import { lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import AppPrivateLayout from '../components/AppPrivateLayout';
import RoleGuard from '../components/RoleGuard';
import LogoutPage from '../pages/LogoutPage';
import UnauthorizedPage from '../pages/UnauthorizedPage';

const DashboardPage = lazy(() => import('../pages/DashboardPage'));
const GeneralImportingPage = lazy(
  () => import('../pages/CTETMSDataUploadPage'),
);
const IntegrationsGollumPage = lazy(
  () => import('../pages/IntegrationsGollumPage'),
);
const IntegrationsPage = lazy(
  () => import('../pages/IntegrationsPage/IntegrationsPage'),
);
const RegistrationsPage = lazy(() => import('../pages/RegistrationsPage'));
const SynchroDocumentPage = lazy(() => import('../pages/SynchroDocumentPage'));

interface ProtectedRoute {
  path: string;
  component: React.LazyExoticComponent<React.ComponentType>;
  requiredRoles: string[];
  requireAll?: boolean;
}

const protectedRoutes: ProtectedRoute[] = [
  {
    path: '/integrations',
    component: IntegrationsPage,
    requiredRoles: ['SUPPORT'],
  },
  {
    path: '/integrationsGollum',
    component: IntegrationsGollumPage,
    requiredRoles: ['SUPPORT'],
  },
  {
    path: '/registrations',
    component: RegistrationsPage,
    requiredRoles: ['SUPPORT'],
  },
  {
    path: '/synchro',
    component: SynchroDocumentPage,
    requiredRoles: ['FISCAL'],
  },
  {
    path: '/ctetms',
    component: GeneralImportingPage,
    requiredRoles: ['USER'],
  },
];

const AppRoutes = () => (
  <Routes>
    <Route element={<AppPrivateLayout />}>
      <Route index path="/" element={<DashboardPage />} />

      {protectedRoutes.map(
        ({ path, component: Component, requiredRoles, requireAll }) => (
          <Route
            key={path}
            path={path}
            element={
              <RoleGuard requiredRoles={requiredRoles} requireAll={requireAll}>
                <Component />
              </RoleGuard>
            }
          />
        ),
      )}
    </Route>

    <Route path="/logout" element={<LogoutPage />} />

    <Route path="/unauthorized" element={<UnauthorizedPage />} />

    <Route path="*" element={<Navigate to={'/'} replace />} />
  </Routes>
);

export default AppRoutes;
